import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  listarDocumentosCatalogo,
  crearDocumentoCatalogo,
  actualizarDocumentoCatalogo,
} from "../../../services/documentosCatalogoService";
import { showToast } from "../../../utils/showToast";

export default function ConfiguracionDocumentos() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState(null);

  const [mostrarForm, setMostrarForm] = useState(false);
  const [nombreNuevo, setNombreNuevo] = useState("");
  const [requeridoNuevo, setRequeridoNuevo] = useState(false);
  const [creando, setCreando] = useState(false);

  const cargar = () => {
    setLoading(true);
    listarDocumentosCatalogo()
      .then((data) => setItems(Array.isArray(data) ? data : []))
      .catch(() => showToast({ type: "danger", message: "No se pudo cargar el catálogo de documentos." }))
      .finally(() => setLoading(false));
  };

  useEffect(cargar, []);

  const toggleActivo = async (item) => {
    setSavingId(item.id);
    try {
      await actualizarDocumentoCatalogo(item.id, { activo: item.activo ? 0 : 1 });
      setItems((prev) => prev.map((i) => (i.id === item.id ? { ...i, activo: i.activo ? 0 : 1 } : i)));
      showToast({ type: "success", message: item.activo ? "Documento desactivado." : "Documento activado." });
    } catch (err) {
      showToast({ type: "danger", message: err.message || "No se pudo actualizar." });
    } finally {
      setSavingId(null);
    }
  };

  const toggleRequerido = async (item) => {
    setSavingId(item.id);
    try {
      await actualizarDocumentoCatalogo(item.id, { requerido: item.requerido ? 0 : 1 });
      setItems((prev) => prev.map((i) => (i.id === item.id ? { ...i, requerido: i.requerido ? 0 : 1 } : i)));
    } catch (err) {
      showToast({ type: "danger", message: err.message || "No se pudo actualizar." });
    } finally {
      setSavingId(null);
    }
  };

  const agregar = async (e) => {
    e.preventDefault();
    if (!nombreNuevo.trim()) {
      showToast({ type: "warning", message: "Ingresa un nombre para el documento." });
      return;
    }
    setCreando(true);
    try {
      const creado = await crearDocumentoCatalogo({ nombre: nombreNuevo.trim(), requerido: requeridoNuevo });
      setItems((prev) => [...prev, { ...creado, requerido: creado.requerido ? 1 : 0, activo: 1 }]);
      setNombreNuevo("");
      setRequeridoNuevo(false);
      setMostrarForm(false);
      showToast({
        type: "success",
        message: `Documento agregado. Código: "${creado.codigo}" — usa ese mismo código al registrarlo en el panel de Docco.`,
        duration: 9000,
      });
    } catch (err) {
      showToast({ type: "danger", message: err.message || "No se pudo agregar el documento." });
    } finally {
      setCreando(false);
    }
  };

  return (
    <section className="management-page management-theme-teal configuracion-wrapper">
      <div className="container-fluid">
        <div className="management-card management-header mb-4">
          <div className="d-flex align-items-center gap-2 mb-1">
            <Link to="/dashboard/configuracion" className="text-muted text-decoration-none small">
              <i className="bi bi-chevron-left me-1"></i>Configuración
            </Link>
          </div>
          <div className="dashboard-eyebrow">Configuración / Documentos</div>
          <h5 className="mb-1">Catálogo de documentos</h5>
          <p className="text-muted mb-0">
            Activa, desactiva o agrega los tipos de documento que se piden a los estudiantes —
            en Ademy y en el Campus. Desactivar uno no borra los documentos ya subidos con ese tipo.
          </p>
        </div>

        {loading ? (
          <div className="text-muted">Cargando...</div>
        ) : (
          <div className="card border-0 shadow-sm">
            <div className="table-responsive">
              <table className="table align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Documento</th>
                    <th style={{ width: 110 }} className="text-center">Requerido</th>
                    <th style={{ width: 110 }} className="text-center">Activo</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item) => (
                    <tr key={item.id} className={item.activo ? "" : "text-muted"}>
                      <td>{item.nombre}</td>
                      <td className="text-center">
                        <div className="form-check form-switch d-flex justify-content-center">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={!!item.requerido}
                            disabled={savingId === item.id}
                            onChange={() => toggleRequerido(item)}
                          />
                        </div>
                      </td>
                      <td className="text-center">
                        <div className="form-check form-switch d-flex justify-content-center">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={!!item.activo}
                            disabled={savingId === item.id}
                            onChange={() => toggleActivo(item)}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="card-body border-top">
              {mostrarForm ? (
                <form className="row g-2 align-items-end" onSubmit={agregar}>
                  <div className="col-12 col-md-6">
                    <label className="form-label small mb-1">Nombre del documento</label>
                    <input
                      className="form-control"
                      placeholder="Ej: Examen de aptitud física"
                      value={nombreNuevo}
                      onChange={(e) => setNombreNuevo(e.target.value)}
                    />
                  </div>
                  <div className="col-auto">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="doc-nuevo-requerido"
                        checked={requeridoNuevo}
                        onChange={(e) => setRequeridoNuevo(e.target.checked)}
                      />
                      <label className="form-check-label" htmlFor="doc-nuevo-requerido">Requerido</label>
                    </div>
                  </div>
                  <div className="col-auto d-flex gap-2">
                    <button type="submit" className="btn management-btn-primary" disabled={creando}>
                      {creando ? "Agregando..." : "Agregar"}
                    </button>
                    <button type="button" className="btn btn-outline-secondary" onClick={() => setMostrarForm(false)}>
                      Cancelar
                    </button>
                  </div>
                </form>
              ) : (
                <button type="button" className="btn management-btn-primary" onClick={() => setMostrarForm(true)}>
                  <i className="bi bi-plus-lg me-1" />Agregar documento
                </button>
              )}
            </div>
          </div>
        )}

        <div className="alert alert-light border small mt-3">
          <i className="bi bi-info-circle me-1" />
          Un documento nuevo que no tenga un extractor especializado en Docco se analiza con
          validación genérica (contexto de palabras clave y coincidencia de nombre) — se
          configura en el panel de Docco, no aquí.
        </div>
      </div>
    </section>
  );
}
